import React from 'react';
import IProcessMapNodeViewModel from '@Shared.Angular/@types/processMapNodeViewModel';
import TagList from '@Shared.Angular/flowingly.components/TagList/TagList';
import ITagGroupDetail from '@Shared.Angular/@types/core/contracts/queryModel/tagGroup/tagGroupDetail';

type Props = {
  selectedNode: IProcessMapNodeViewModel;
};

const tagGroupsFormatted = (tagGroups: ITagGroupDetail[]) => {
  const result: Record<string, { tags: string[]; color: string }> = {};
  tagGroups.forEach((group) => {
    result[group.name] = {
      tags: group.tags.map((tag) => tag.name),
      color: group.color
    };
  });
  return result;
};

const StepTags = (props: Props) => {
  const { selectedNode } = props;
  return (
    <div className="pmap-step-tags-tab">
      <TagList
        groupedSelectedTags={tagGroupsFormatted(selectedNode.tags || [])}
      />
    </div>
  );
};

export default StepTags;
